<script setup lang="ts">
import { ref, computed, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStation } from '@/store/station';
import { useChargeManagement } from '@/store/charge-management';
import { useUserStore } from '@/store/user';
import { useLoadingOverlay } from '@/store/overlays/loading-overlay';

const { t } = useI18n();
const station = useStation();
const charge_management = useChargeManagement();
const user = useUserStore();
const loading_overlay = useLoadingOverlay();

// const props = defineProps<{ text: string }>();

const confirmation_sheet_visible = ref<boolean>(false);
const stop_charge_pending = ref<boolean>(false);

// const button_text = computed((): string => props.text ?? t("stop_charge"));
const button_text = computed((): string => t("stop_charge"));

async function stop_charge(): Promise<void> {
  loading_overlay.show();
  console.log("[stop-charge]: stopping charge");
  await charge_management.do_stop_charge();
  console.log("[stop-charge]: charge stopped");
  console.log("[stop-charge]: fetching cs");
  await station.do_fetch(station.qrcode, true);
  console.log("[stop-charge]: cs fetched");
  loading_overlay.hide();
}
function show_confirmation() {
  confirmation_sheet_visible.value = true;
}
async function hide_confirmation(confirm_close_charge: boolean): Promise<void> {
  confirmation_sheet_visible.value = false;
  if (confirm_close_charge) {
    stop_charge_pending.value = true;
    await stop_charge();
    stop_charge_pending.value = false;
  }
}

onBeforeUnmount(() => { loading_overlay.hide(); user.fetch(); })
</script>

<template>
  <v-container fill-height>
    <!-- Stop charge button -->
    <v-layout class="justify-center align-center pb-2">
      <v-btn
        :loading="stop_charge_pending"
        elevation="3"
        class="bg-warning text-uppercase font-weight-bold"
        size="x-large"
        @click.stop="show_confirmation"
      >
        {{ button_text }}
      </v-btn>
    </v-layout>
    <!-- Confirmation sheet -->
    <v-overlay
      v-model="confirmation_sheet_visible"
      persistent
      no-click-animation
      style="background-color: rgba(0, 0, 0, 0.4); z-index: 1500; margin-top: 65px;"
    >
      <v-bottom-sheet
        v-model="confirmation_sheet_visible"
        persistent
        no-click-animation
        style="z-index: 2500;"
        @click:outside="hide_confirmation(false)"
      >
        <v-sheet
          color="white"
          class="text-center text-uppercase"
        >
          <v-col
            class="pt-3 pb-5 subtitle-1 font-weight-bold text-secondary align-center text-wrap"
          >
            <span>{{ t("confirm_stop_charge") }}</span>
          </v-col>
          <v-row class="justify-center mb-3 font-weight-bold" style="width: 100vw;">
            <v-btn
              size="x-large"
              class="bg-success mr-2"
              @click.stop="hide_confirmation(true)"
            >
              {{ t("yes") }}
            </v-btn>
            <v-btn size="x-large" class="bg-error ml-2" @click="hide_confirmation(false)">
              {{ t("no") }}
            </v-btn>
          </v-row>
        </v-sheet>
      </v-bottom-sheet>
    </v-overlay>
  </v-container>
</template>

<i18n lang="yaml">
en:
  stop_charge: "Stop charge"
  confirm_stop_charge: "Are you sure you want stop charging?"
  yes: Yes
  no: No
it:
  stop_charge: "Interrompere la ricarica"
  confirm_stop_charge: "Sei sicuro di voler interrompere la ricarica?"
  yes: Si
  no: No
fr:
  stop_charge: "Arrêter la charge"
  confirm_stop_charge: "Êtes-vous sûr de vouloir arrêter la charge ?"
  yes: Oui
  no: Non
de:
  stop_charge: "Aufhören zu laden"
  confirm_stop_charge: "Sind Sie sicher, dass Sie den Ladevorgang beenden?"
  yes: Ja
  no: Nein
nl:
  stop_charge: "Opladen stoppen"
  confirm_stop_charge: "Weet u zeker dat u wilt stoppen met opladen?"
  yes: Ja
  no: Nee
</i18n>

<style scoped lang="scss">
</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
